"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetOpportunityQueryDto = void 0;
const tslib_1 = require("tslib");
const class_validator_1 = require("class-validator");
const class_transformer_1 = require("class-transformer");
const swagger_1 = require("@nestjs/swagger");
const constants_1 = require("../../../../../../services/service-lib/src/lib/constants");
class GetOpportunityQueryDto {
    constructor() {
        this.page = constants_1.DEFAULT_VALUES.PAGE;
        this.limit = constants_1.DEFAULT_VALUES.LIMIT;
    }
}
exports.GetOpportunityQueryDto = GetOpportunityQueryDto;
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Page number for pagination.",
        example: constants_1.DEFAULT_VALUES.PAGE,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1, { message: "Page must be at least 1" }),
    tslib_1.__metadata("design:type", Number)
], GetOpportunityQueryDto.prototype, "page", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Number of records per page(by default limit is 10 records).",
        example: constants_1.DEFAULT_VALUES.LIMIT,
    }),
    (0, class_transformer_1.Transform)(({ value }) => parseInt(value, 10)),
    (0, class_validator_1.IsNumber)(),
    (0, class_validator_1.Min)(1, { message: "Limit must be at least 1" }),
    tslib_1.__metadata("design:type", Number)
], GetOpportunityQueryDto.prototype, "limit", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Search term to filter opportunities by company name.",
        example: "opportunityStage: Under Review, opportunityPriority: High",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetOpportunityQueryDto.prototype, "search", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Sort must be a string.",
        example: "opportunityId: ASC",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetOpportunityQueryDto.prototype, "sort", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Search by based on the property.",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetOpportunityQueryDto.prototype, "searchBy", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Field to filter by date (e.g., createdAt, updatedAt).",
        example: "createdAt",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetOpportunityQueryDto.prototype, "field", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Start date for the filter.",
        example: "2023-01-01T00:00:00.000Z",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    tslib_1.__metadata("design:type", typeof (_a = typeof Date !== "undefined" && Date) === "function" ? _a : Object)
], GetOpportunityQueryDto.prototype, "from", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "End date for the filter.",
        example: "2023-12-31T23:59:59.999Z",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsDate)(),
    (0, class_transformer_1.Type)(() => Date),
    tslib_1.__metadata("design:type", typeof (_b = typeof Date !== "undefined" && Date) === "function" ? _b : Object)
], GetOpportunityQueryDto.prototype, "to", void 0);
tslib_1.__decorate([
    (0, swagger_1.ApiPropertyOptional)({
        description: "Period of time in which the opportunity was created.",
        example: "3 Months",
    }),
    (0, class_validator_1.IsOptional)(),
    (0, class_validator_1.IsString)(),
    tslib_1.__metadata("design:type", String)
], GetOpportunityQueryDto.prototype, "period", void 0);
